import { type InfiniteData, type QueryClient } from 'react-query'

import { type IInfinitePage } from 'types/interfaces/ITypes'

const deletePostCache = async (
    postId: string,
    dataQuery: any,
    queryClient: QueryClient
) => {
    await queryClient.cancelQueries({ queryKey: dataQuery })

    const cachedData =
        queryClient.getQueryData<InfiniteData<IInfinitePage>>(dataQuery)

    if (cachedData) {
        const newData = {
            ...cachedData,
            pages: cachedData.pages.map(singleFeedPage => {
                return {
                    ...singleFeedPage,
                    page: {
                        ...singleFeedPage.page,
                        data: {
                            ...singleFeedPage.page.data,
                            data: singleFeedPage.page.data.data.filter(
                                post => post.id !== postId
                            )
                        }
                    }
                }
            })
        }

        queryClient.setQueryData(dataQuery, newData)
    }
    return { cachedData }
}

export { deletePostCache }
